module.exports = __webpack_public_path__ + "img/report.f2b0f166.png";